var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-default',[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{staticClass:"px-md-12 px-4 text-center"},[_c('h1',{staticClass:"mt-4"},[_vm._v("IP restrictions")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }